// extracted by mini-css-extract-plugin
export default {"LicensePlate":"LicensePlate2_LicensePlate__KQW92","LicenseInput":"LicensePlate2_LicenseInput__dtClX"};